import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Container, Grid, Menu, MenuItem, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/CustomButton";
import TopBar from "../../../components/TopBar/TopBar";
import { getPendingStocksByClinic } from "../../../redux/reducers/clinicSlice";
import { AppColors } from "../../../util/AppColors";
import Main from "./Dashboard.js/Main";
import Location from "./Location";
import PurchaseHistory from "./PurchaseHistory";
import Service from "./Service";
import Stock from "./Stock";
import Main2 from "./StockDashboard.js/Main2";
import StockRequest from "./StockRequest";
import Supplier from "./Supplier";

const Inventory = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("Stock");
  const [penTblVsble, setPenTblVsble] = useState(false);
  const { pendingStocks } = useSelector((state) => state?.clinic);
  const [anchorEl, setAnchorEl] = useState(null);
  const [serviceOption, setServiceOption] = useState("Service"); // Default
  const [stockOption, setStockOption] = useState("Stock"); // default
  // Define separate anchors
  const [serviceAnchorEl, setServiceAnchorEl] = useState(null);
  const [stockAnchorEl, setStockAnchorEl] = useState(null);
  const [masterAnchorEl, setMasterAnchorEl] = useState(null);
  const [masterSubTab, setMasterSubTab] = useState("Location");

  useEffect(() => {
    dispatch(getPendingStocksByClinic(`?type=pending&page=1&itemSize=10`));
  }, []);

  const handlePending = () => {
    setActiveTab("Stock");
    setPenTblVsble(true);
  };

  const handleChangeTab = (tab) => {
    setPenTblVsble(false);
    setActiveTab(tab);
  };

  return (
    <>
      <TopBar>
        <Container maxWidth="xl">
          <Grid container spacing={2}>
            <Grid
              item
              xs={4}
              sm={4}
              md={2}
              lg={1.5}
              xl={1}
              onMouseEnter={(e) => {
                setStockAnchorEl(e.currentTarget);
              }}
              onMouseLeave={() => setStockAnchorEl(null)}
            >
              <Button
                text={
                  <span
                    style={{ display: "flex", alignItems: "center", gap: 4 }}
                  >
                    {stockOption}
                    <ArrowDropDownIcon
                      style={{ color: "gray", fontSize: 20 }}
                    />
                  </span>
                }
                tabSelectdBtn={activeTab === "Stock"}
                textBtn={activeTab !== "Stock"}
                color={AppColors.grayBtn2}
              />
              <Menu
                anchorEl={stockAnchorEl}
                open={Boolean(stockAnchorEl)}
                onClose={() => setStockAnchorEl(null)}
                MenuListProps={{
                  onMouseEnter: () => {},
                  onMouseLeave: () => setStockAnchorEl(null),
                }}
              >
                <MenuItem
                  onClick={() => {
                    setStockOption("Stock");
                    setActiveTab("Stock");
                    setStockAnchorEl(null);
                  }}
                >
                  Stock
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setStockOption("Dashboard");
                    setActiveTab("Stock");
                    setStockAnchorEl(null);
                  }}
                >
                  Dashboard
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setStockOption("Requests");
                    setActiveTab("Stock");
                    setStockAnchorEl(null);
                  }}
                >
                  Requests
                </MenuItem>
              </Menu>
            </Grid>
            <Grid
              item
              xs={4}
              sm={4}
              md={2}
              lg={1.5}
              xl={1}
              onMouseEnter={(e) => {
                setServiceAnchorEl(e.currentTarget);
              }}
              onMouseLeave={() => setServiceAnchorEl(null)}
            >
              <Button
                text={
                  <span
                    style={{ display: "flex", alignItems: "center", gap: 4 }}
                  >
                    {serviceOption}
                    <ArrowDropDownIcon
                      style={{ color: "gray", fontSize: 20 }}
                    />
                  </span>
                }
                tabSelectdBtn={activeTab === "Service"}
                textBtn={activeTab !== "Service"}
                color={AppColors.grayBtn2}
              />
              <Menu
                anchorEl={serviceAnchorEl}
                open={Boolean(serviceAnchorEl)}
                onClose={() => setServiceAnchorEl(null)}
                MenuListProps={{
                  onMouseEnter: () => {},
                  onMouseLeave: () => setServiceAnchorEl(null),
                }}
              >
                <MenuItem
                  onClick={() => {
                    setServiceOption("Service");
                    setActiveTab("Service");
                    setServiceAnchorEl(null);
                  }}
                >
                  Service
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setServiceOption("Dashboard");
                    setActiveTab("Service");
                    setServiceAnchorEl(null);
                  }}
                >
                  Dashboard
                </MenuItem>
              </Menu>
            </Grid>
            <Grid item xs={4} sm={4} md={2} lg={1.5} xl={1}>
              <div
                onMouseEnter={(e) => {
                  setMasterAnchorEl(e.currentTarget);
                }}
                className={`flex-center cursor ${
                  activeTab === "Master"
                    ? "pet-det-sel-tab"
                    : "pet-det-un-sel-tab"
                }`}
              >
                Master <ArrowDropDownIcon fontSize="small" />
              </div>
              <Menu
                anchorEl={masterAnchorEl}
                open={Boolean(masterAnchorEl)}
                onClose={() => setMasterAnchorEl(null)}
                MenuListProps={{
                  onMouseLeave: () => setMasterAnchorEl(null),
                }}
              >
                <MenuItem
                  onClick={() => {
                    setMasterSubTab("Location");
                    setActiveTab("Master");
                    setMasterAnchorEl(null);
                  }}
                >
                  Location
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setMasterSubTab("Supplier");
                    setActiveTab("Master");
                    setMasterAnchorEl(null);
                  }}
                >
                  Supplier
                </MenuItem>
              </Menu>
              {/* <Button
                text="Location"
                tabSelectdBtn={activeTab === "Location"}
                textBtn={activeTab !== "Location"}
                onClick={() => handleChangeTab("Location")}
                color={AppColors.grayBtn2}
              /> */}
            </Grid>
            <Grid item xs={4} sm={4} md={2} lg={1.5} xl={1}>
              <Button
                text="Purchase History"
                tabSelectdBtn={activeTab === "Purchase History"}
                textBtn={activeTab !== "Purchase History"}
                color={AppColors.grayBtn2}
                onClick={() => setActiveTab("Purchase History")}
              />
            </Grid>
          </Grid>
        </Container>
        <div className="pos-absolute r80 top65">
          <Typography
            className="fs14 txt-semi-bold orange-color cursor"
            onClick={handlePending}
          >
            Pending {pendingStocks?.totalRecords}
          </Typography>
        </div>
      </TopBar>
      <div
        className="mt20"
        style={{
          height: "calc(100vh - 130px)",
          overflowY: "auto",
          // paddingRight: "10px",
        }}
      >
        {activeTab === "Service" &&
          (serviceOption === "Service" ? <Service /> : <Main />)}
        {activeTab === "Stock" &&
          (stockOption === "Stock" ? (
            <Stock penTblVsble={penTblVsble} setPenTblVsble={setPenTblVsble} />
          ) : stockOption === "Requests" ? (
            <StockRequest />
          ) : (
            <Main2 />
          ))}
        {/* {activeTab === "Supplier" && <Supplier />} */}
        {/* {activeTab === "Master" && masterSubTab === "Location" && <Location />} */}
        {activeTab === "Master" &&
          (masterSubTab === "Location" ? (
            <Location />
          ) : masterSubTab === "Supplier" ? (
            <Supplier />
          ) : null)}
        {activeTab === "Purchase History" ? <PurchaseHistory /> : null}
      </div>
    </>
  );
};

export default Inventory;
